import React from "react";

const Intro2 = ({ language }) => {
  const text = getText(language);
  return <div>{text}</div>;
};

export default Intro2;

const getText = (language) => {
  switch (language) {
    case "en":
      return (
        <>
          <p>
            The purpose of this app is to help establish whether you or your
            client are likely to have a permanent right to reside in the UK
            under EU law.
          </p>
          <p>
            <strong>
              If you are found to have a permanent right to reside, this means
              that:
            </strong>
          </p>
          <ul>
            <li>
              You have the <strong>right to travel</strong> in and out of the UK{" "}
              <strong>and to remain</strong> in the UK permanently; regardless
              of whether you are exercising treaty rights. This means that you
              do not have to demonstrate that you are a student, working,
              self-employed, job-seeking or self-sufficient to remain in the UK.
            </li>
            <li>
              You can <strong>access and apply</strong> for healthcare, pensions
              and benefits on the same basis as a UK national. You will be
              subject to the same eligibility requirements as a UK national, but
              cannot be denied access to such benefits on the basis of your
              immigration status alone.
            </li>
            <li>
              You can <strong>apply for British</strong> citizenship after
              living in the UK for one year after you acquire permanent
              residence status, or immediately if you are married to or in a
              civil partnership with a British citizen.
            </li>
            <li>
              You can lose your right to reside{" "}
              <strong>if you are absent</strong> from the UK for two years or
              more at one time.
            </li>
            <li>
              A <strong>decision to refuse you admission</strong> to the UK,
              exclude you from the UK, revoke your residence or remove you from
              the UK, can only be taken because there are serious grounds of
              public policy or public security to justify this decision (this
              only usually applies if you have committed a serious crime).
            </li>
          </ul>
          <p>
            <strong>
              Please be aware that, as a result of Brexit, permanent residence
              status will not provide you with a valid right to reside in the UK
              after 31 December 2020. To continue living in the UK after that
              date, you should apply to the EU Settlement Scheme.
            </strong>
          </p>
        </>
      );
    case "bg":
      return (
        <>
          <p>
            Целта на тази апликация е да Ви помогне да прецените дали Вие или
            Вашият клиент е възможно да има право на постоянно пребиваване в
            Обединеното Кралство според европейското право.
          </p>
          <p>
            <strong>
              Ако е решено, че сте добили право на постоянно пребиваване, това
              значи че:
            </strong>
          </p>
          <ul>
            <li>
              Имате право да пътувате в и извън Обединеното Кралство и да
              останете в Обединеното Кралство постоянно, независимо дали
              упражнявате права по договорите на ЕС в Обединеното Кралство. Това
              означава, че вие не трябва да доказвате, че сте ученик, работещ,
              самонает, търсещ работа или самостоятелно издържащо се лице, за да
              останете в Обединеното Кралство.
            </li>
            <li>
              Имате право на достъп и да кандидатствате за здравеопазване,
              образование, пенсия и помощи на същата основа като гражданин на
              Обединеното Кралство. Вие ще трябва да покриете същите изисквания
              като британски гражданин, но не може да Ви бъде отказано само въз
              основа на имиграционния Ви статут.
            </li>
            <li>
              Може да кандидатствате за британско гражданство 1 година след като
              сте получили право на постоянно пребиваване или веднага, ако сте
              съпруг/граждански партньор на британски гражданин.
            </li>
            <li>
              Вие може да изгубите правото си на постоянно пребиваване, ако сте
              извън Обединеното Кралство за 2 или повече години наведнъж.
            </li>
            <li>
              Решение да Ви бъде отказано влизането в Обединеното Кралство, да
              не бъдете допуснати в Обединеното Кралство, правото Ви на
              постоянно пребиваване да бъде прекратено или да бъдете премахнати
              от Обединеното Кралство, може да бъде взето само защото има
              сериозни основания въз основа на обществения ред или обществената
              сигурност, които да доведат до такова решение (обикновено това се
              прилага само ако сте извършили тежко престъпление).
            </li>
          </ul>
          <p>
            <strong>
              Моля, имайте предвид, че в резултат на Брекзит правото Ви на
              постоянно пребиваване няма да Ви предостави право на пребиваване в
              Обединеното кралство след 31 декември 2020. За да продължите да
              живеете в Обединеното кралство след тази дата, трябва да
              кандидатствате по схемата за уседналост на ЕС
            </strong>
          </p>
        </>
      );
    case "it":
      return (
        <>
          <p>
            Lo scopo di questa applicazione è quello di aiutare a verificare se
            tu o il tuo cliente abbiate il diritto ad ottenere la residenza
            permanente in GB ai sensi della normativa UE.
          </p>
          <p>
            <strong>
              Se venisse accertato che hai un diritto di residenza
              permanentemente, ciò significherebbe che:
            </strong>
          </p>
          <ul>
            <li>
              hai il diritto di viaggiare dentro e fuori la GB e rimanere in GB
              permanentemente; indipendentemente se stai esercitando i diritti
              di un trattato. Ciò significa che non devi dimostrare che sei uno
              studente, che stai lavorando, che sei un lavoratore autonomo, che
              stai cercando lavoro o che sei autosufficiente per rimanere il GB.
            </li>
            <li>
              puoi accedere e richiedere assistenza medica, pensioni e
              prestazioni sullo stesso livello di un cittadino britannico. Sarai
              soggetto agli stessi requisiti di ammissibilità di un cittadino
              britannico, ma non ti sarà potuto negare l'accesso a tali
              prestazioni sull'esclusiva base del tuo status immigratorio.
            </li>
            <li>
              puoi fare richiesta della cittadinanza dopo aver vissuto in GB per
              un anno dopo aver ottenuto il tuo status di residenza permanente,
              o immediatamente dopo che ti sei sposato o ti sei unito in una
              unione civile con un cittadino britannico.
            </li>
            <li>
              puoi perdere il tuo diritto di residenza permanente se sei assente
              dalla BG per due o più anni consecutivamente.
            </li>
            <li>
              una decisione che rifiuti la tua entrata in GB, ti escluda dalla
              GB, revochi il tuo diritto di residenza o ti espella dalla GB, può
              essere presa solo perché ci sono gravi motivi di ordine pubblico o
              sicurezza pubblica che giustifichino tale decisione (questo
              solitamente si applica quando commetti gravi crimini).
            </li>
          </ul>
          <p>
            <strong>
              Ti preghiamo di considerare che, a seguito della Brexit, lo status
              di residente permanente non ti darà diritto di rimanere in GB dopo
              il 31 dicembre 2020. Per continuare a vivere in GB dopo quella
              data, devi fare applicazione al EU Settlement Scheme.
            </strong>
          </p>
        </>
      );
    case "ru":
      return (
        <>
          <p>
            Если установлено, что вы имеете право на постоянное проживание, это
            означает, что:
          </p>
          <p>
            <strong>
              Se venisse accertato che hai un diritto di residenza
              permanentemente, ciò significherebbe che:
            </strong>
          </p>
          <ul>
            <li>
              У вас есть право въезжать и выезжать из Великобритании и постоянно
              находиться в Великобритании; независимо от того, пользуетесь ли вы
              правами по международному договору.Это означает, что вам не нужно
              доказывать, что вы студент, работаете, являетесь индивидуальным
              предпринимателем, ищете работу или являетесь самодостаточным
              лицом, для того чтобы оставаться в Великобритании.
            </li>
            <li>
              Вы можете получить доступ и подать заявление на получение
              медицинского обслуживания, пенсий и льгот на тех же основаниях,
              что и граждане Великобритании. К вам будут предъявляться те же
              требования, что и к гражданину Великобритании, но вам не может
              быть отказано в доступе к таким льготам только на основании вашего
              иммиграционного статуса.
            </li>
            <li>
              Вы можете подать заявление на получение британского гражданства
              после проживания в Великобритании в течение одного года после
              получения статуса постоянного жителя или сразу же, если вы
              состоите в браке или в гражданском партнерстве с гражданином
              Великобритании.
            </li>
            <li>
              Вы можете потерять право на проживание, если отсутствуете в
              Великобритании в течение двух или более лет.
            </li>
            <li>
              Решение отказать вам во въезде в Великобританию, исключить вас из
              Великобритании, аннулировать ваше ПМЖ или выселить вас из
              Великобритании может быть принято только если, существуют
              серьезные основания государственной политики или общественной
              безопасности, оправдывающие это решение (это обычно применяется,
              только если вы совершили тяжкое преступление).
            </li>
          </ul>
          <p>
            <strong>
              Имейте в виду, что в результате Брексита статус постоянного
              проживания ("permanent residence") не предоставит вам
              действительное право проживать в Великобритании после 31 декабря
              2020 года. Чтобы продолжить проживание в Великобритании после этой
              даты, вам следует подать заявление заявление по Схеме Поселенцев
              ЕС ("EU Settlement Scheme").
            </strong>
          </p>
        </>
      );
    case "es":
      return (
        <>
          <p>
            El propósito de esta aplicación es ayudar a establecer si es
            probable que usted o su cliente tengan un derecho a la residencia
            permanente en el Reino Unido en virtud de la normativa de la UE.
          </p>
          <p>
            <strong>
              Si se comprueba que usted tiene un derecho permanente de
              residencia, significa que:
            </strong>
          </p>
          <ul>
            <li>
              Tiene derecho a entrar y salir del Reino Unido y a permanecer en
              el Reino Unido de forma permanente; independientemente de si está
              ejerciendo los derechos del tratado. Esto significa que no tiene
              que demostrar que es estudiante, trabajador por cuenta ajena o
              propia, solicitante empleo o que es autosuficiente para permanecer
              en el Reino Unido.
            </li>
            <li>
              Puede acceder y solicitar asistencia sanitaria, pensiones y
              prestaciones en las mismas condiciones que un ciudadano británico.
              Estará sujeto a los mismos requisitos de elegibilidad que un
              ciudadano británico, pero no se le puede negar el acceso a dichos
              beneficios sólo por su condición de inmigrante.
            </li>
            <li>
              Puede solicitar la ciudadanía británica después de vivir en el
              Reino Unido después un año tras haber adquirido la residencia
              permanente, o inmediatamente si está casado o en unión civil con
              un ciudadano británico.
            </li>
            <li>
              Puede perder su derecho a la residencia si se ausenta del Reino
              Unido durante dos años o más consecutivos.
            </li>
            <li>
              La decisión de denegarle la admisión al Reino Unido, excluirle del
              Reino Unido, revocar su residencia o expulsarle del Reino Unido,
              sólo puede tomarse porque existen razones graves de orden o
              seguridad pública que justifiquen esta decisión (esto sólo suele
              aplicarse si usted ha cometido un delito grave).
            </li>
          </ul>
          <p>
            <strong>
              Tenga en cuenta que, como resultado de Brexit, la condición de
              residente permanente no le dará derecho válido a residir en el
              Reino Unido después del 31 de diciembre de 2020. Para continuar
              viviendo en el Reino Unido después de esa fecha, debe solicitar el
              Programa de Establecimiento de la UE.
            </strong>
          </p>
        </>
      );
    case "hi":
      return (
        <>
          <p>
            इस ऐप का उद्देश्य यह स्थापित करने में मदद करना है कि क्या आप या आपके
            ग्राहक को यूरोपीय संघ के कानून के तहत यूके में निवास करने का स्थायी
            अधिकार होने की संभावना है।
          </p>
          <p>
            <strong>
              यदि आपको निवास करने का स्थायी अधिकार मिल गया है, तो इसका मतलब है
              कि:
            </strong>
          </p>
          <ul>
            <li>
              आपको यूके में और बाहर यात्रा करने और स्थायी रूप से यूके में रहने
              का अधिकार है; आप संधि अधिकारों का प्रयोग कर रहे हैं या नहीं। इसका
              मतलब है कि आपको यह प्रदर्शित करने की आवश्यकता नहीं है कि आप
              ब्रिटेन में रहने के लिए एक छात्र, कामकाजी, स्वरोजगार, नौकरी की
              तलाश या आत्मनिर्भर हैं।
            </li>
            <li>
              आप यूके के राष्ट्रीय स्तर पर स्वास्थ्य सेवा, पेंशन और लाभ के लिए
              आवेदन कर सकते हैं। आप ब्रिटेन की राष्ट्रीय के रूप में एक ही
              पात्रता आवश्यकताओं के अधीन होंगे, लेकिन अकेले आपकी आव्रजन स्थिति
              के आधार पर ऐसे लाभों तक पहुंच से इनकार नहीं किया जा सकता है।
            </li>
            <li>
              स्थायी निवास का दर्जा प्राप्त करने के तुरंत बाद या एक ब्रिटिश
              नागरिक के साथ नागरिक साझेदारी में या उससे विवाह करने पर आप ब्रिटेन
              में रहने के एक साल बाद तक ब्रिटिश नागरिकता के लिए आवेदन कर सकते
              हैं।
            </li>
            <li>
              यदि आप दो साल या उससे अधिक समय से यूके से अनुपस्थित हैं, तो आप
              निवास करने का अधिकार खो सकते हैं।
            </li>
            <li>
              यूके में आपको प्रवेश देने से इनकार करने, आपको यूके से बाहर करने,
              अपने निवास को रद्द करने या आपको यूके से निकालने का निर्णय केवल
              इसलिए लिया जा सकता है क्योंकि इस निर्णय को सही ठहराने के लिए
              सार्वजनिक नीति या सार्वजनिक सुरक्षा के गंभीर आधार हैं (केवल आमतौर
              पर लागू होता है यदि आपने एक गंभीर अपराध किया है)।
            </li>
          </ul>
          <p>
            <strong>
              कृपया ध्यान रखें कि ब्रेक्सिट के परिणामस्वरूप, स्थायी निवास का
              दर्जा आपको 31 दिसंबर 2020 के बाद यूके में रहने का वैध अधिकार
              प्रदान नहीं करेगा। उस तारीख के बाद यूके में रहने के लिए, आपको ईयू
              सेटलमेंट स्कीम के लिए आवेदन करना चाहिए। ।
            </strong>
          </p>
        </>
      );

    default:
      break;
  }
};
